import { Injectable, Pipe } from '@angular/core';

@Pipe({
  name: 'texttrim'
})

export class TextTrimPipe
{
  transform(text: string, args: string[])
  {
    var value = '';
      if(text.length > 9){
        value = text.substr(0,9) + '.....';
      }else{
        value = text;
      }
  

    return value;
  }
}